/* eslint-disable @typescript-eslint/no-explicit-any */
import { assetFragment, topicOverviewFragment } from "../fragments";
import {
    ITemplatePageLoader,
    flattenTemplateImageAssets
} from "../get-content-data";

export const AgileOverviewPageLoader: ITemplatePageLoader = {
    getQueryData: (urlSlug: string, locale: string) => {
        return {
            query: `
                query getAgileOverview ($search: ContentPlatformSearchAPIv2Query!) {
                    topicOverviews(search: $search) {
                        edges {
                            node {
                                ...topicOverviewFragmentFull
                            }
                        }
                    }
                }
                ${topicOverviewFragment}
                ${assetFragment}
            `,
            variables: {
                search: {
                    queries: {
                        first: 1,
                        withLocales: [locale],
                        where: {
                            searchText: {
                                exactlyMatching: {
                                    fieldNamed: "urlSlug",
                                    havingValues: [urlSlug]
                                }
                            }
                        }
                    }
                }
            }
        };
    },
    parseData: (data: any) => {
        return flattenTemplateImageAssets(data.topicOverviews.edges[0].node);
    }
};
